import React, {useState} from 'react';
import './step.css';
import {HelpVideoModal} from '@/components/common';
import {WebSvg} from '@/assets';

interface Props extends ApplicationStep {
  active: boolean;
  completed: boolean;
  isLast: boolean;
}

function Step(props: Props) {
  const [show, setShow] = useState(false);

  const icon = props.active ? 'ActiveStepIcon' : 'DefaultStepIcon';

  return (
    <React.Fragment>
      <div className="d-flex align-items-start pt-1">
        <img src={WebSvg[props.completed ? 'CompletedStepIcon' : icon]} />
      </div>
      <div className="steps d-flex  flex-column px-1">
        <div className="head d-flex align-items-center">
          <span className="text-nowrap">{props.title}</span>
          {!props.isLast && <WebSvg.StepLine />}
        </div>
        <div onClick={() => setShow(true)} className="stepHelp">
          <img src={WebSvg.StepHelp} /> Help
        </div>
        <HelpVideoModal
          visible={show}
          close={() => setShow(false)}
          url={props.help_url}
          description={props.help_description}
        />
      </div>
    </React.Fragment>
  );
}

export default Step;
